export enum FormBuilderActions {
  ADD_FIELD = 'add_field',
  DELETE_FIELD = 'delete_field',
  NEXT_STEP = 'next_step',
}
